module.exports = __webpack_public_path__ + "static/media/libraryiconhover.cf20f4a8.svg";